export default __webpack_public_path__ + "static/media/footer-3.c09b0ed2.jpg";